import React from 'react';
import { useTranslation } from 'react-i18next';

interface CreateGameButtonProps {
  onClick: () => void;
  loading: boolean;
}

const CreateGameButton: React.FC<CreateGameButtonProps> = ({ onClick, loading }) => {
  const { t } = useTranslation();
  return (
    <button 
      onClick={onClick} 
      disabled={loading}
      className="w-full bg-orange-400 hover:bg-orange-500 disabled:opacity-70 disabled:cursor-not-allowed text-white font-black py-4 px-6 rounded-3xl text-2xl uppercase tracking-wide shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
    >
      {loading ? t('home.creating') : t('home.createGame')}
    </button>
  );
};

export default CreateGameButton;